import { render } from "./SubcategoryView.vue?vue&type=template&id=586df62c"
import script from "./SubcategoryView.vue?vue&type=script&lang=js"
export * from "./SubcategoryView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__